import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/desktop.css';
import App from './App';
import { isTauri } from './utils/tauri';

// Desktop build only: tag <html> so the desktop shell CSS (custom title bar
// offset, chrome positioning) applies. Done before render so there's no
// layout shift on first paint. The web build never gets this class.
if (isTauri()) {
  document.documentElement.classList.add('tauri-app');
}

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Failed to find the root element');

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
